import { SxProps, Theme } from '@mui/material';

export const menuItemSx: SxProps<Theme> = {
    color: '#ffffff',
    '&:hover': {
        backgroundColor: '#ffffff',
        color: '#084897',
    },
};

export const listMenuItemSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        backgroundColor: '#084897',
    },
    '& .MuiList-root': {
        backgroundColor: '#084897',
    },
    '& .MuiTypography-root': {
        backgroundColor: 'transparent !important',
        '&:hover': {
            color: '#084897 !important',
        },
    },
        '& .MuiMenuItem-root:hover .MuiTypography-root': {
            color: '#084897 !important',
        },
    '& .MuiMenuItem-root': {
        color: '#ffffff !important',
        backgroundColor: '#084897 !important',
        '&:hover': {
            backgroundColor: '#f5f3f3 !important',
            color: '#084897 !important',
        },
    },
};